<!--
 * @Author: Matt.Xu matt.xu@gtechdigi.com
 * @Date: 2024-06-26 11:07:15
 * @LastEditors: Matt.Xu matt.xu@gtechdigi.com
 * @LastEditTime: 2024-06-28 11:10:44
 * @FilePath: /ua-cnbs-mall/src/components/Coupons/CouponRulePopup.vue
 * @Description: 从src/components/Common/couponRule.vue，拆出来的，没想好
 * 
 * Copyright (c) 2024 by 佳应科技, All Rights Reserved. 
-->
<template>
  <van-popup v-model="visible" position="bottom" class="coupon-rule">
    <div class="coupon-rule-title">
      <p>使用规则</p>
      <img src="@/assets/ua-icon24/icon-close.svg" alt="icon-close" @click="visible = false" />
    </div>
    <div class="coupon-rule-content">
      <div class="commodity"></div>
      <ul>
        <li
          v-if="(couponData && couponData.detailsInfo) || (couponData && couponData.details)"
          v-html="couponData.detailsInfo || couponData.details"
        ></li>
      </ul>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'RulePopup',
  data() {
    return {
      visible: false,
      couponData: {}
    };
  },
  methods: {
    showPopup(couponData) {
      this.couponData = couponData || {};
      this.visible = true;
    },
    hidePopup() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-rule {
  padding: 20px 20px 32px;
}
.coupon-rule-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 22px;
  p {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 600;
  }
  img {
    width: 16px;
    height: 16px;
  }
}
.coupon-rule-content {
  .commodity {
    margin: 20px 0;
  }
  ul {
    li {
      color: var(--main-color-ua-dark-grey, #14141e);
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 8px;
      line-height: 18px;
    }
    li:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
